import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

interface SetupBottomNavigationProps {
  currentSection: "company" | "profile" | "review" | "alerts";
  onBack?: () => void;
  onSkip?: () => void;
  onSaveAndNext?: () => void;
  isSubmitting?: boolean;
  canGoBack?: boolean;
  canSkip?: boolean;
  backDisabled?: boolean;
  skipDisabled?: boolean;
  saveNextDisabled?: boolean;
  saveNextButtonText?: string;
}

const SetupBottomNavigation: React.FC<SetupBottomNavigationProps> = ({
  currentSection,
  onBack,
  onSkip,
  onSaveAndNext,
  isSubmitting = false,
  canGoBack = true,
  canSkip = true,
  backDisabled = false,
  skipDisabled = false,
  saveNextDisabled = false,
  saveNextButtonText = "Save and next",
}) => {
  return (
    // <div className="setup-bottom-navigation">
    <div className="setup-bottom-navigation__container">
      {/* Left side - Back button */}
      <div className="setup-bottom-navigation__left">
        {canGoBack && onBack && (
          <></>
          // <button
          //   className="btn-back-figma"
          //   onClick={onBack}
          //   disabled={backDisabled || isSubmitting}
          //   type="button"
          // >
          //   <FontAwesomeIcon icon={faChevronLeft} />
          //   <span>Back</span>
          // </button>
        )}
      </div>

      {/* Right side - Skip and Save and next buttons */}
      <div className="setup-bottom-navigation__right">
        {canSkip && onSkip && (
          <button
            className="setup-nav-btn-skip"
            onClick={onSkip}
            disabled={skipDisabled || isSubmitting}
            type="button"
          >
            <span>Skip</span>
            <FontAwesomeIcon icon={faChevronRight} className="setup-nav-btn-icon" />
          </button>
        )}
        {onSaveAndNext && (
          <button
            className="btn-save-next-figma"
            onClick={onSaveAndNext}
            disabled={saveNextDisabled || isSubmitting}
            type="button"
          >
            <span>{saveNextButtonText}</span>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        )}
      </div>
    </div>
    // </div>
  );
};

export default SetupBottomNavigation;
